const manageSpacecraft = {
    manage: {
        pageTitle: '위성 관리',
        pageDescription: '등록된 위성 정보를 확인하고 관리하세요',
        grid: {
            name: 'Name',
            noradId: 'Norad ID',
            tleTitle: 'TLE - Title Line',
            direction: 'Direction',
            band: 'Band',
            centerFrequency: 'Center Frequency',
            registeredAt: 'Registered At',
            tleUpdate: 'TLE Update',
            viewDetails: '상세 보기',
            update: '갱신'
        },
        button: {
            searchPlaceholder: '검색',
            delete: '삭제',
            add: '위성 등록',
            viewDetails: '상세보기',
            update: '업데이트',
            cancel: '취소',
            next: '다음',
            getTle: 'Get TLE',
            previous: '이전',
            done: '완료',
            save: '저장',
            edit: '수정'
        },
        message: {
            tleUpdated: 'TLE가 업데이트되었습니다.'
        },
        modal: {
            title: 'Add Spacecraft',
            name: 'Name',
            noradId: 'NORAD ID',
            tleTitle: 'TLE - Title',
            tleLine1: 'TLE - Line 1',
            tleLine2: 'TLE - Line 2',
            direction: 'Direction',
            band: 'Band',
            centerFrequency: 'Center Frequency (MHz)',
            modulation: 'Modulation',
            bitRate: 'Bit Rate',
            polarization: 'Polarization',
            convolutionalCode: 'Convolutional Code or Derandomization',
            reedsolomonCode: 'Reed-Solomon Code (FEC)',
            subFrequency: 'Subcarrier Frequency',
            pcmCoding: 'PCM Coding',
            frameSyncWord: 'Sync Word',
            frameSize: 'Frame Size',
            syn: 'SYN',
            ctl: 'CTL',
            lts: 'LTS',
            slip: 'SLIP',
            other: '(Optional) Other',
            directionId: 'Direction ID',
            bandId: 'Band ID',
            modulationId: 'Modulation ID',
            polarizationId: 'Polarization ID',
            convCodeId: 'Conv. Code ID',
            rsCodeId: 'RS Code ID',
            pcmCodingId: 'PCM Coding ID',
            randomization: 'Randomization',
            randomizationId: 'Randomization ID',
            syncStrategy: 'Sync Strategy',
            detail: {
                name: 'Name',
                noradId: 'NORAD ID',
                tleTitle: 'TLE - Title',
                tleLine1: 'TLE - Line 1',
                tleLine2: 'TLE - Line 2',
                direction: 'Direction',
                band: 'Band',
                centerFrequency: 'Center Frequency',
                modulationName: 'Modulation',
                bitRate: 'Bit Rate',
                polarizationName: 'Polarization',
                convolutionalCodeName: 'Convolutional Code',
                rsCodeName: 'Reed-Solomon Code',
                subFrequency: 'Subcarrier Frequency',
                pcmCodingName: 'PCM Coding',
                frameSyncWord: 'Sync Word',
                frameSize: 'Frame Size',
                syn: 'SYN',
                ctl: 'CTL',
                lts: 'LTS',
                slip: 'SLIP',
                other: 'Other'
            },
            deleteTitle: '삭제',
            deleteMessage: '정말 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.'
        },
        tab: {
            downlink: 'Downlink',
            uplink: 'Uplink',
            sband: 'S-Band',
            xband: 'X-Band'
        },
        tooltip: {
            name: 'This is the name used when searching for a schedule.',
            noradId: "It automatically fills in when you click 'Get TLE' or press Enter.",
            centerFrequency: 'Tx : 2025 ~ 2120  Rx : 2200 ~ 2300',
            bitRate: 'Min : 1,000bps / Max : 40,000,000bps',
            subFrequency: 'High bandwidth with sub-carrier',
            frameSyncWord: 'Base: 0x1ACFFC1D (32bit, 4byte)',
            syncStrategy: 'Synchronization strategy using SYN/CTL/LTS/SLIP',
        },
        placeholder: {
            noradId: "It automatically fills in when you click 'Get TLE' or press Enter.",
            centerFrequency: 'Tx : 2025 ~ 2120  Rx : 2200 ~ 2300',
            bitRate: 'Min: 500,000bps   Max: 12,000,000,000bps',
            subFrequency: '0 to 2,000,000 (in Hz)',
        },
    }
};

export default manageSpacecraft;
